'use client'
import { NextPage } from 'next';
import React, { useState } from 'react'
import Footer from '@/components/footer/page';
import Header from '@/components/header2/page';
import { Findmore } from '@/components/Findmore/page';
import { Oswald } from 'next/font/google'
import BottomFooter from '@/components/BottomFooter/BottomFooter';
import { useAppSelector } from "@/redux/store";
import { GoArrowLeft } from "react-icons/go";
import { useRouter, usePathname } from 'next/navigation'
import { Roboto } from 'next/font/google';
import { Fredoka } from "next/font/google";
import { IoSearch } from "react-icons/io5";
const oswalds = Oswald({ subsets: ['latin'] })
const roboto = Roboto({ weight: ['700',], subsets: ['latin'] })
const fredoka = Fredoka({ subsets: ["latin"] });
import { SearchBar } from '@/components/SearchBar/searchBar';

interface Heading {
  head: string;
}

interface Findmore {
  id: number;
  name: string;

}

interface imageInfo {
  eventId: number;
  image_url: string;
}

interface PerformerContentProps {
  heading: Heading;
  findmore: Findmore[];
  imageInfo: imageInfo[];
  performer_id?: number;
  showHomeAway: boolean;
}

const PerformerPageContent: NextPage<PerformerContentProps> = ({ heading, findmore, imageInfo, performer_id, showHomeAway }) => {

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState<string>('');

  const isPWA = useAppSelector((state: any) => state.pwacheckReducer.isPWA);

  const router = useRouter();
  const [onClickLoading, setOnClickLoading] = useState(false);

  const handleBackClick = () => {
    router.back();
  };


  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      {!isPWA && (
        <Header heading={{ head: heading.head, slug: "" }} loading={loading} setLoading={setLoading} />
      )}
      {isPWA && (
        <div className='mt-[10px]'>
          <div className='flex space-x-2 w-[90%] mx-auto mb-3'>
            <button onClick={handleBackClick}>
              <GoArrowLeft className="text-black text-center h-8 w-8" />
            </button>
            <div className='flex'>
              <div className={`${roboto.className} font-normal text-xl text-center text-black`}>{heading.head}</div>
              {/* <div className={`${roboto.className} font-normal text-xl text-center text-black`}>{heading.head} |&nbsp;</div> */}
              {/* <div className={`${roboto.className} font-normal text-xl text-center text-black`}>Slug</div> */}
            </div>
          </div>
          {/* <div className="flex justify-center items-center w-[90%] rounded-full bg-[#EBEDF0] mx-auto">
            <IoSearch className="h-6 w-6 mx-2 my-1" />
            <div className="w-[87%] pt-4 ml-[17px]">
              <SearchBar
                className="lg:w-[647px] md:w-[400px] w-full rounded-full flex flex-col relative gap-10 border-2 border-neutral-400 "
                className1="bg-[#3BC3F2] flex items-center justify-center h-full text-white "
                styles={{
                  divstyle: {
                    borderRadius: "41px",
                    display: "flex",
                    flexDirection: "row-reverse",
                  },
                }}
                setLoading={setOnClickLoading}
              />
            </div>
            <input
              type="text"
              className="w-full h-10 bg-[#EBEDF0] outline-none text-gray-700 rounded-full placeholder-gray-700"
              placeholder="Search by teams"
              value={searchTerm}
              onChange={handleSearch}
            />
          </div> */}
           <div className="w-[87%] pt-4 ml-[17px]">
              <SearchBar
                className="lg:w-[647px] md:w-[400px] w-full rounded-full flex flex-col relative gap-10 border-2 border-neutral-400 "
                className1="bg-[#3BC3F2] flex items-center justify-center h-full text-white "
                styles={{
                  divstyle: {
                    borderRadius: "41px",
                    display: "flex",
                    flexDirection: "row-reverse",
                  },
                }}
                setLoading={setOnClickLoading}
              />
            </div>
        </div>
      )}

      {
        !loading && <>
          {!isPWA && (
            <> <h1 className={`${oswalds.className} uppercase text-center text-xl md:text-4xl bg-[#fafbfb] font-medium pt-10 flex justify-center`}>UPCOMING EVENTS OF - {heading.head}</h1></>
          )}

          <Findmore findmore={findmore} imageInfo={imageInfo} performer_id={performer_id} showHomeAway={showHomeAway} />
        </>
      }
      {isPWA && (
        <><br /><br /><br /></>
      )}

      <BottomFooter />
    </>
  )

}

export default PerformerPageContent